import Papa from 'papaparse'
import { BatchLookupCsvRow } from './batchLookupToCsvRows'

export type BatchCsvFilterOptions = 'needs_tlc' | 'fix_category' | 'no_match'

const BATCH_LOOKUP_CSV_HEADERS = [
  'store',
  'name',
  'alias',
  'product_type',
  'needs_tlc',
  'fix_category',
  'no_match',
  'assignee_id',
  'assignee_name',
  'assignee_url',
] as const

export const makeBatchLookupCsv = (
  batchLookupCSVRows: BatchLookupCsvRow[],
  options: { filter?: BatchCsvFilterOptions } = {}
) => {
  // Remove rows marked 'ignored'
  let filteredRows = batchLookupCSVRows.filter((r) => !r.ignored)

  // Filter by workstream tag
  if (options.filter) {
    const filter = options.filter
    filteredRows = filteredRows.filter((r) => r[filter] === 'yes')
  }

  // If resulting csv would have no rows return null
  if (filteredRows.length === 0) return null

  const csvBody = filteredRows.map((el) => [
    el.store,
    el.name,
    el.alias,
    el.product_type,
    el.needs_tlc,
    el.fix_category,
    el.no_match,
    el.assignee_id,
    el.assignee_name,
    el.assignee_url,
  ])

  return Papa.unparse([BATCH_LOOKUP_CSV_HEADERS, ...csvBody])
}
